<template>
  <Teleport to="#modals">
    <Modal v-if="route.name === 'ChangePassword'">
      <template #header-all>
        <h2 v-if="route.query.temporaryPassword">
          Необходимо установить постоянный пароль
        </h2>
        <h2 v-else>Необходимо установить новый пароль</h2>
      </template>
      <template #content>
        <ChangePasswordForm
          @success="handleSuccess"
          :label-old-password="
            route.query.temporaryPassword
              ? 'Временный пароль'
              : 'Текущий пароль'
          "
        />
      </template>
    </Modal>
    <Modal v-else @close="() => emit('close')">
      <template #header-all>
        <BackButton :click="() => emit('close')" type="button">
          Отмена
        </BackButton>
      </template>
      <template #content>
        <ChangePasswordForm @success="handleSuccess" />
      </template>
    </Modal>
  </Teleport>
</template>

<script setup>
import Modal from '@/components/Modal.vue'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import { useStore } from 'vuex'
import BackButton from '@/components/BackButton.vue'
import useAuth from '@/utils/useAuth'
import { useRoute } from 'vue-router'

defineProps({
  isTemporaryPassword: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close'])

const route = useRoute()
const store = useStore()
const { removeTokens, setVrio } = useAuth()

const handleSuccess = () => {
  emit('close')

  removeTokens()
  setVrio(false)

  store.dispatch('showSuccess', {
    text: 'Ваш пароль успешно изменен',
    btnText: 'Войти в сервис',
    onClick: () => location.reload(),
  })
}
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  padding: 0 20px;
}
</style>
